import { FC } from 'react';
import classNames from 'classnames';
import { localeStore } from '~/mobx/localesStore';
import { MaskedInput } from '~/view/components/Controls/Inputs';
import Text, { TEXT } from '~/view/components/Text/Text';
import './style.scss';

interface IProps {
  title: string;
  value: string;
  error?: boolean;
  hidden?: boolean;
  onChange: (value: string | undefined) => void;
}

const CheckoutProfileApiKey: FC<IProps> = ({ title, value, onChange, error, hidden }): JSX.Element => {
  const validation = error ? { isValid: false, errorText: localeStore.t('required_field_error') } : { isValid: true, errorText: '' };
  return (
    <div
      className={classNames('mt-2', {
        hidden,
      })}
    >
      <Text type={TEXT.BLOCK_HEADER} text={localeStore.t(title)} required />
      <MaskedInput
        value={value}
        onChangeValue={onChange}
        className="mt-2"
        validation={validation}
        contentClassName="checkout-profile-api-key__input"
      />
    </div>
  );
};

export default CheckoutProfileApiKey;
